import styled from 'styled-components';
import Progress from '@clds/progress';
import { useMessage } from '../i18n/useMessage';

const LoaderLayout = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  height: 100%;
`;

const StyledProgress = styled(Progress.Logo)`
  width: 15%;
  max-width: 130px;
`;

export const Loader = () => {
  const t = useMessage();
  return (
    <LoaderLayout>
      <StyledProgress size="xl" aria-label={t('loading')} />
    </LoaderLayout>
  );
};
